export const CHECKOUT = "/checkout";
export const DEFAULT = "";
export const DASHBOARD_MEMBERS = "/dashboard_members";
export const DASHBOARD_GYM_OWNERS = "/dashboard_gyms_owners";
export const HOME = "/";
export const SIGNUP_GYM_OWNERS = "/signup_new_partner";
export const LIST_YOUR_BUSINESS = "/signup_new_partner/list";
export const LOGIN_TESTING = "/login_testing_eom_devs";
export const ADMIN_DASHBOARD = "/admin-dashboard";
export const SIGNUP = "/signup";
export const SELECT_GYM = "/select-gym";
export const PAYMENT = "/payment";
export const WAITLIST = "/waitlist";
